// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { DEFAULT_AUTHENTICATED_PATH } from "@/lib/routes";

export const Route = createFileRoute("/")({
  validateSearch: z.object({ state: z.string().optional() }),
  beforeLoad: ({ search }) => {
    // An SSO callback can land on the bare root as /?state=… . The state is a one-time claim token
    // that only the login page consumes, so forward it there — bouncing to the app would drop it.
    if (search.state) {
      throw redirect({ to: "/login", search: { state: search.state } });
    }
    throw redirect({ to: DEFAULT_AUTHENTICATED_PATH });
  },
});
